<template>
    <div class="align-center">
        <div class="flyer-thumb-list" tabindex="0">
       
       <component :is="blockComponent" v-for="flyer in thumbs" :key="flyer.title" :flyer-data="flyer" />
  
 </div>
    </div>
    
</template>

<script>
import FlyerThumbButton from "@/features/flyer-selector/FlyerThumbButton.vue";
import FlyerThumbButtonVertical from "@/features/flyer-selector/FlyerThumbButtonVertical.vue";
import {mapGetters} from "vuex";
import featureMixin from "@/mixins/featureMixin";

export default {
	name: "FlyerThumbList",
	components: {FlyerThumbButton, FlyerThumbButtonVertical},
    mixins:[featureMixin],
    data(){
		return {
			featurePath: 'flyerSelector',
		}
	},
	computed: {
		...mapGetters('landingPage', ['sortedFlyers']),
        ...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		thumbs() {
        return this.sortedFlyers;
		},
        blockComponent() {
            if (this._config.isCompactView) return FlyerThumbButtonVertical;
            else return FlyerThumbButton
        
        },
	}
}
</script>

<style scoped>

</style>
